import { connect, Dispatch } from 'react-redux';
import { AppState, history } from 'src';
import { ContractBalancesComponentProperties, ContractBalancesComponent } from './contract-balances.component';
import { getContractDetails } from 'src/contract/contract.actions';
import { ContractBalancesViewModel } from '@models/Contract';
import {
  getContractBalances,
  selectBalance,
  saveContractCheckPayment,
  getPaymentSources,
  clearBalances
} from 'src/contract/_components/contract-balances/contract-balances.actions';
import { ContractCheckPaymentViewModel } from '@models/Payment';
import { RouteDefinitions, getRoute } from '@common/route-definitions';

export interface ContractBalancesProperties {
  readonly buttonRef: (button: HTMLButtonElement) => void;
}

// This is used to translate the state of the page to the props on the component
function mapStateToProps(
  state: AppState,
  ownProps: ContractBalancesProperties
): Partial<ContractBalancesComponentProperties> {
  return {
    contractDetailsVM: state.contract.contractDetailsVM!,
    balancesList: state.contract.contractBalances.balancesList,
    selectedBalances: state.contract.contractBalances.selectedBalances,
    paymentSources: state.contract.contractBalances.paymentSources
  };
}

// This should create proxy wrappers for actions used by the component
function mapDispatchToProps(dispatch: Dispatch<AppState>): Partial<ContractBalancesComponentProperties> {
  return {
    getContractDetails: (id: number) => {
      dispatch(getContractDetails(id));
    },
    getContractBalances: (id: number) => {
      dispatch(getContractBalances(id));
    },
    handleSelectBalance: (balance: ContractBalancesViewModel) => {
      dispatch(selectBalance(balance));
    },
    openCreditCardModal: (hostedCheckoutButton?: HTMLButtonElement) => {
      if (hostedCheckoutButton) {
        hostedCheckoutButton.click();
        return;
      }
    },
    getPaymentSources: () => {
      dispatch(getPaymentSources());
    },
    saveCheckPayment: async (checkPayment: ContractCheckPaymentViewModel) => {
      await dispatch(saveContractCheckPayment(checkPayment));
      history.push(getRoute(RouteDefinitions.contract.Details, { id: checkPayment.contractId }));
    },
    clearBalances: () => {
      dispatch(clearBalances());
    }
  };
}

// Connect function "wires" both of the map functions and returns a wrapper container for the component
export const ContractBalances = connect(
  mapStateToProps,
  mapDispatchToProps
)(ContractBalancesComponent);



// WEBPACK FOOTER //
// ./src/contract/_components/contract-balances/_components/contract-balances.container.ts